import { Box, Typography } from "@mui/joy";
import { ImportExportRounded, ShareRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";

import { Button, IconButton } from "../../../../shared";
import { RefreshCcw } from "lucide-react";

export function Title(props: ITitle) {
    const { onRefreshClick, svc } = props;
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Box display={"flex"} alignItems={"center"} flex={1} justifyContent={"space-between"}>
            <Box>
                <Typography level="title-lg">All Projects</Typography>
                <Typography level="body-xs">{svc?.data?.length || 0} Items</Typography>
            </Box>
            <Box display={"flex"} gap={1}>
                <IconButton color="neutral" onClick={onRefreshClick} disabled={svc.isPending} variant="soft">
                    <RefreshCcw
                        size={16}
                        style={svc.isPending ? { animation: "spin 1s linear infinite" } : undefined}
                    />
                </IconButton>
                {isMobile ? (
                    <>
                        <IconButton variant="soft" color="neutral">
                            <ImportExportRounded />
                        </IconButton>
                        <IconButton variant="soft" color="neutral">
                            <ShareRounded />
                        </IconButton>
                    </>
                ) : (
                    <>
                        <Button variant={"soft"} startDecorator={<ImportExportRounded />} size={"sm"} color={"neutral"}>
                            Export
                        </Button>
                        <Button variant={"soft"} startDecorator={<ShareRounded />} size={"sm"} color={"neutral"}>
                            Share
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
}

interface ITitle {
    onRefreshClick: () => void;
    svc: any;
}
